export default "__VITE_ASSET__VCNjsyte__"